import { CALL_API } from '../middleware/ApiMiddleware';

export const VIOLATION_TYPES_FETCH_REQUEST = 'VIOLATION_TYPES_FETCH_REQUEST';
export const VIOLATION_TYPES_FETCH_SUCCESS = 'VIOLATION_TYPES_FETCH_SUCCESS';
export const VIOLATION_TYPES_FETCH_FAILURE = 'VIOLATION_TYPES_FETCH_FAILURE';

export const CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_REQUEST = 'CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_REQUEST';
export const CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_SUCCESS = 'CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_SUCCESS';
export const CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_FAILURE = 'CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_FAILURE';

export const CONFIG_VIOLATION_TYPES_FETCH_REQUEST = 'CONFIG_VIOLATION_TYPES_FETCH_REQUEST';
export const CONFIG_VIOLATION_TYPES_FETCH_SUCCESS = 'CONFIG_VIOLATION_TYPES_FETCH_SUCCESS';
export const CONFIG_VIOLATION_TYPES_FETCH_FAILURE = 'CONFIG_VIOLATION_TYPES_FETCH_FAILURE';

export const VIOLATION_TYPE_FETCH_REQUEST = 'VIOLATION_TYPE_FETCH_REQUEST';
export const VIOLATION_TYPE_FETCH_SUCCESS = 'VIOLATION_TYPE_FETCH_SUCCESS';
export const VIOLATION_TYPE_FETCH_FAILURE = 'VIOLATION_TYPE_FETCH_FAILURE';

export const VIOLATION_TYPES_CREATE_REQUEST = 'VIOLATION_TYPES_CREATE_REQUEST';
export const VIOLATION_TYPES_CREATE_SUCCESS = 'VIOLATION_TYPES_CREATE_SUCCESS';
export const VIOLATION_TYPES_CREATE_FAILURE = 'VIOLATION_TYPES_CREATE_FAILURE';

export const VIOLATION_TYPES_EDIT_REQUEST = 'VIOLATION_TYPES_EDIT_REQUEST';
export const VIOLATION_TYPES_EDIT_SUCCESS = 'VIOLATION_TYPES_EDIT_SUCCESS';
export const VIOLATION_TYPES_EDIT_FAILURE = 'VIOLATION_TYPES_EDIT_FAILURE';

export const SYSTEM_ICONS_FETCH_REQUEST = 'SYSTEM_ICONS_FETCH_REQUEST';
export const SYSTEM_ICONS_FETCH_SUCCESS = 'SYSTEM_ICONS_FETCH_SUCCESS';
export const SYSTEM_ICONS_FETCH_FAILURE = 'SYSTEM_ICONS_FETCH_FAILURE';

const baseURL = 'admin/system-xerce-violation-types';

export const fetchViolationTypes = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [VIOLATION_TYPES_FETCH_REQUEST, VIOLATION_TYPES_FETCH_SUCCESS, VIOLATION_TYPES_FETCH_FAILURE],
  },
});

export const fetchViolationType = (violationTypeId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${violationTypeId}`,
    method: 'get',
    authenticated: true,
    types: [VIOLATION_TYPE_FETCH_REQUEST, VIOLATION_TYPE_FETCH_SUCCESS, VIOLATION_TYPE_FETCH_FAILURE],
  },
});

export const createViolationType = (violationType: ISystemXerceViolationTypeRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'post',
    authenticated: true,
    body: violationType,
    types: [VIOLATION_TYPES_CREATE_REQUEST, VIOLATION_TYPES_CREATE_SUCCESS, VIOLATION_TYPES_CREATE_FAILURE],
  },
});

export const editViolationType = (violationTypeId: number, violationType: IXerceViolationTypeEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${violationTypeId}`,
    method: 'put',
    authenticated: true,
    body: violationType,
    types: [VIOLATION_TYPES_EDIT_REQUEST, VIOLATION_TYPES_EDIT_SUCCESS, VIOLATION_TYPES_EDIT_FAILURE],
  },
});

export const fetchSystemIcons = () => ({
  [CALL_API]: {
    endpoint: 'admin/system-icons',
    method: 'get',
    authenticated: true,
    types: [SYSTEM_ICONS_FETCH_REQUEST, SYSTEM_ICONS_FETCH_SUCCESS, SYSTEM_ICONS_FETCH_FAILURE],
  },
});

export const fetchConfigUnlinkedViolationTypes = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `admin/agencies/${agencyId}/xerce/config/violation-types`,
    method: 'get',
    authenticated: true,
    types: [
      CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_REQUEST,
      CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_SUCCESS,
      CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_FAILURE,
    ],
  },
});

export const fetchConfigViolationTypes = (hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: 'xerce/config/violation-types',
    method: 'get',
    authenticated: true,
    hideLoadingWidget,
    types: [
      CONFIG_VIOLATION_TYPES_FETCH_REQUEST,
      CONFIG_VIOLATION_TYPES_FETCH_SUCCESS,
      CONFIG_VIOLATION_TYPES_FETCH_FAILURE,
    ],
  },
});
